import React, { useState, useRef, useEffect } from 'react';
import { Animated, Image, FlatList, Button } from 'react-native';
import { FileUploader } from "react-drag-drop-files";
import TrackFileRow from '../objects/TrackFileRow';
import TrackFile from '../objects/TrackFile';
import '../public/app.module.css'

var FILES = [];

var sUsrAg = navigator.userAgent;
var fileTypes = ["MP3", "M4A", "WAV", "AIF"];

const DragDropScreen = props => {
  const [refreshData, setRefreshData] = useState(false);

  const handleChange = (files) => {
    for (var i = 0; i < files.length; i++) {
      const f = new TrackFile(files[i], props.route.params.item.id, props.route.params.item.artistId);
      FILES.push({id: FILES.length + i, file: f})
    }
    setRefreshData(!refreshData);
  };

  function handleBackButtonClick() {
    FILES = [];
    props.navigation.navigate(
      'ChooseProjectScreen',
      { item: { id: props.route.params.item.artistId, name: props.route.params.item.artistName } }
    );
  }

  const renderFile = ({ item }) => (
    <TrackFileRow file={item.file}></TrackFileRow>
  );

  const fadeAnim = useRef(new Animated.Value(0)).current  // Initial value for opacity: 0

  useEffect(() => {
    Animated.timing(
      fadeAnim,
      {
        toValue: 1,
        duration: 950,
      }
    ).start();
  }, [fadeAnim])

  return (
    <div className="main">
      <div className="header">
        <div className="row">
          <div className="buttonView">
            <Button
              onPress={handleBackButtonClick}
              title="Back"
            />
          </div>
          <span className="headerText">Upload</span>
        </div>
      </div>
      <div className="container">
        <Animated.View style={{ alignItems: 'center', opacity: fadeAnim }}>
          <img 
            className="tinyProjectImg" 
            src={(props.route.params.item.albumArtRef == null) ?  "https://images.unsplash.com/photo-1557683311-eac922347aa1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8Ymx1ZSUyMGFuZCUyMHB1cnBsZSUyMGdyYWRpZW50fGVufDB8fDB8fA%3D%3D&w=1000&q=80" : props.route.params.item.albumArtRef}
          />
          <span className="nameTextDragDrop">{props.route.params.item.name}</span>
          <FileUploader
            multiple={true}
            handleChange={handleChange}
            name="file"
            types={fileTypes}
          />
          <FlatList
            style={{ paddingTop: 35 }}
            extraData={refreshData}
            data={FILES}
            renderItem={renderFile}
            keyExtractor={item => item.id}
            horizontal={false}
          />
        </Animated.View>
      </div>
    </div>
  );
}

export default DragDropScreen;
